import { StyleSheet } from 'react-native';
import { theme } from '../../theme';

export const verificationFormStyles = StyleSheet.create({
  verificationCard: {
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    paddingTop: 24,
  },
  verificationHint: {
    fontSize: 14,
    color: theme.gray[500],
    marginBottom: 20,
    textAlign: 'center',
    paddingHorizontal: 20,
  },
});
